// src/redux/languageActions.js
export const TOGGLE_LANGUAGE = "TOGGLE_LANGUAGE";
export const SET_LANGUAGE = "SET_LANGUAGE";

export const toggleLanguage = () => ({
  type: TOGGLE_LANGUAGE,
});

export const setLanguage = (language) => ({
  type: SET_LANGUAGE,
  payload: Number(language) === 1 ? 1 : 0,
});

export const getLanguageFromQuery = (search) => {
  if (!search) return null;
  try {
    const params = new URLSearchParams(search);
    const lang = (
      params.get("lang") ||
      params.get("language") ||
      params.get("hl") ||
      ""
    )
      .toLowerCase()
      .trim();

    const hindiVal = params.get("hindi")?.toLowerCase()?.trim();
    const isHindiTrue =
      hindiVal === "" ||
      hindiVal === "true" ||
      hindiVal === "1" ||
      hindiVal === "yes";

    if (
      lang === "hi" ||
      lang === "hindi" ||
      lang === "1" ||
      (params.has("hindi") && isHindiTrue)
    ) {
      return 1;
    }

    const engVal = params.get("english")?.toLowerCase()?.trim();
    const isEngTrue =
      engVal === "" ||
      engVal === "true" ||
      engVal === "1" ||
      engVal === "yes";

    if (
      lang === "en" ||
      lang === "english" ||
      lang === "0" ||
      (params.has("english") && isEngTrue)
    ) {
      return 0;
    }
  } catch (e) {
    console.error("Error parsing language query:", e);
  }
  return null;
};
